import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { ICellRendererParams } from "@ag-grid-community/core";
import { formatNumber } from "@angular/common";
import { ChangeDetectionStrategy, Component, signal } from "@angular/core";
import { InventoryStats, RuleExecutionResult } from "@front/m19-models";
import { IIconComponent } from "@front/m19-ui";

@Component({
  selector: "app-estimated-days-renderer",
  standalone: true,
  template: ` <div class="flex items-center justify-between">
    <IIcon name="octagonPause" class="{{ stateVisible() }} justify-end text-xl" />
    <span>{{ estimatedDaysOfStock() }}</span>
  </div>`,
  imports: [IIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EstimatedDaysRendererComponent implements ICellRendererAngularComp {
  locale: string = "US";
  stateVisible = signal("");
  estimatedDaysOfStock = signal<number | undefined>(undefined);

  agInit(
    params: ICellRendererParams<InventoryStats, RuleExecutionResult | undefined> & {
      locale: string;
    },
  ): void {
    this.locale = params.locale;
    this.estimatedDaysOfStock.set(params.value?.estimatedDaysOfStock);
    this.stateVisible.set(params.value?.shouldPauseAdvertising ? "" : "invisible");
  }

  refresh(
    params: ICellRendererParams<InventoryStats, RuleExecutionResult | undefined> & {
      locale: string;
    },
  ) {
    this.locale = params.locale;
    this.estimatedDaysOfStock.set(params.value?.estimatedDaysOfStock);
    this.stateVisible.set(params.value?.shouldPauseAdvertising ? "" : "invisible");
    return true;
  }

  formatNumber(value?: number) {
    return value ? formatNumber(value, this.locale, "1.0-0") : "";
  }
}
